import EditIcon from "assets/images/components/EditIcon";
import LoadingIcon from "assets/images/components/LoadingIcon";
import Input from "components/Input";
import Select from "components/Select";
import TitleSection from "components/TitleSection";

import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { calculatePension } from "services/calculatePension";


const ages = Array.from({ length: 44 }, (value, index) => ({ "Label": index + 25, "Value": index + 25 }))

// ages from 50 to 80
const pensionAges = Array.from({ length: 30 }, (value, index) => ({ "Label": index + 50, "Value": index + 50 }))

const genders = [{Label: "Female", Value: "F"}, {Label: "Male", Value: "M"}];

const Calculation = ({onCalculationComplete}) => {
  const { t } = useTranslation();

  const [formValues, setFormValues] = useState({
    gender: 'F',
    age: 25,
    pensionAge: 68,
    partTime: 100,
    salary: 80000,
    accumulatedCapital: 100000,
  });
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
  const [isButtonLoading, setIsButtonLoading] = useState(false);

  const updateValues = (value, name) => {
    setFormValues((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  useEffect(() => {
    setIsSubmitDisabled(
      Object.values(formValues).filter(
        (value) => value === undefined || value.length === 0
      ).length > 0
    );
  }, [formValues]);

  const onSubmit = async () => {
    setIsButtonLoading(true);
    setTimeout(async () => {
      const result = await calculatePension(formValues);
      onCalculationComplete(result)
      setIsButtonLoading(false);
      toast.success("Calculated!");
    }, 200);
  };

  return (
    <div className="calculation">
      <TitleSection
        title={t("dashboard.calculation.title")}
        Icon={EditIcon}
        description={t("dashboard.calculation.description")}
      />
      <p style={{marginTop: "4em"}}/>

      <h3>{t("dashboard.calculation.employee")}</h3>
      <form>
        <Select
          name="gender"
          selectLabel={t("dashboard.gender")}
          selectData={genders}
          defaultValue={{Label: "Male", Value: "M"}}
          onSelect={(selectedOption) => {
            updateValues(selectedOption.Value, "gender");
          }}
        />
        <Select
          name="age"
          selectLabel={t("dashboard.age")}
          selectData={ages}
          defaultValue={{Value: 45, Label: "45"}}
          onSelect={(selectedOption) => {
            updateValues(selectedOption.Value, "age");
          }}
        />
        <Select
          name="pensionAge"
          selectLabel={t("dashboard.pensionAge")}
          selectData={pensionAges}
          defaultValue={{Value: 68, Label: "68"}}
          onSelect={(selectedOption) => {
            updateValues(selectedOption.Value, "pensionAge");
          }}
        />

        <Input
          name="salary"
          label={t("dashboard.salary")}
          isCurrencyInput
          defaultValue={80000}
          onChange={(value) => updateValues(value, "salary")}
        />
        <Input
          name="partTime"
          label={t("dashboard.partTime")}
          defaultValue={100}
          onChange={(value) => updateValues(value, "partTime")}
        />
        <Input
          name="accumulatedCapital"
          label={t("dashboard.accumulatedCapital")}
          isCurrencyInput
          defaultValue={100000}
          onChange={(value) => updateValues(value, "accumulatedCapital")}
        />
        <button
          type="button"
          onClick={onSubmit}
          disabled={isSubmitDisabled || isButtonLoading}
          className="button__submit"
        >
          {t("dashboard.submit")}
          {isButtonLoading && <LoadingIcon width={16} height={25} />}
        </button>
      </form>
    </div>
  );
};

export default Calculation;
